import Logger from "../../logger";
import BrowserInfo from "../../../helper/browser-info";
import LandmarkHelper from "../helper";

const USER_INFO_LANDMARKED = 'userInfoLandmarked';

export default function(element, data, sendLandmark) {
    const identifier = LandmarkHelper.getSessionId();
    if(localStorage.getItem(USER_INFO_LANDMARKED) !== identifier) {
        Object.assign(data, BrowserInfo.getBrowserInfo());
        data.landmark = 'UserInfo';
        sendLandmark(data);
        try {
            localStorage.setItem(USER_INFO_LANDMARKED, identifier);
        } catch (e) {
            Logger.debug('[LANDMARK] SessionStorage cannot be set for BrowserInfoLandmark ' + e);
        }
    }
}
